<template>
  <div class="row f-row justify-content-center">
    <div
      class="row f-row mt-1 mb-1 justify-content-center"
      style="vertical-align: middle!important;"
    >
      <div class="col col-auto txt-label-primary-2 text-center">
        {{ selectedAssetType === 0 ? "Currency" : "Commodity" }}:
      </div>
      <div class="col col-2 ml-2 text-left" v-if="selectedAssetType === 0">
        <Dropdown
          v-model="newSelectedAsset"
          :options="
            currencySpecs.map(function(d, i) {
              return { asset: d.currency_name, id: i };
            })
          "
          @change="onUserAssetSelection"
          optionLabel="asset"
          optionValue="id"
          placeholder="Select Currency"
          scrollHeight="400px"
          :filter="true"
        >
          <template #value="slotProps">
            <span style="color: var(--textactive-2)">{{
              currencySpecs[slotProps.value].currency_name.toUpperCase()
            }}</span>
          </template>
          <template #option="slotProps">
            <div class="country-item">
              <div>{{ slotProps.option.asset }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
      <div class="col col-2 ml-2 text-left" v-else>
        <Dropdown
          v-model="newSelectedAsset"
          :options="
            currencySpecs.map(function(d, i) {
              return { asset: d.fk_idproduct.toUpperCase(), id: i };
            })
          "
          @change="onUserAssetSelection"
          optionLabel="asset"
          optionValue="id"
          placeholder="Select Commodity"
          scrollHeight="400px"
          :filter="true"
        >
          <template #value="slotProps">
            <span style="color: var(--textactive-2)">{{
              currencySpecs[slotProps.value].fk_idproduct.toUpperCase()
            }}</span>
          </template>
          <template #option="slotProps">
            <div class="country-item">
              <div>{{ slotProps.option.asset }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
      <div
        class="col col-auto txt-label-primary-2 text-center"
        v-show="selectedAssetType === 1"
      >
        <i
          class="fa fa-question-circle txt-label-primary-2"
          style="display: inline; font-size: 1.3rem!important; padding-left: 5px!important"
          @mouseover="onHoverHelp(true)"
          @mouseleave="onHoverHelp(false)"
        ></i>
      </div>

      <div
        class="col col-auto txt-label-primary-2 text-right"
        v-show="selectedAssetType === 0"
      >
        <span style="padding-left: 8px"> {{ leftCurrency }}:</span>
      </div>
      <div class="col col-2 d-flex">
        <label
          :for="'selectBuySell'"
          class="toggle__button_rt"
          style="height: 65%; margin: auto!important; width: 100%;"
          :class="{ actives: selectedPositionBoolean }"
        >
          <input
            type="checkbox"
            @click="onUserPositionChange"
            :id="'selectBuySell'"
            v-model="selectedPositionBoolean"
          />
          <span
            class="toggle__switch_rt"
            style="margin-left: 0.5rem; width: 100%;"
          >
            <div class="row f-row justify-content-center">
              <div
                class="col col-6 txt-label-primary-2 text-center"
                style="font-size: 0.75rem!important;"
              >
                Buy
              </div>
              <div
                class="col col-6 txt-label-primary-2 text-center"
                style="font-size: 0.75rem!important;"
              >
                Sell
              </div>
            </div>
          </span>
        </label>
      </div>

      <div
        class="col col-auto txt-label-primary-2 text-center"
        v-if="selectedAssetType === 1"
      >
        <span style="padding-left: 12px;">Contract:</span>
      </div>
      <div class="col col-2 ml-2 mr-3 text-left" v-if="selectedAssetType === 1">
        <Dropdown
          v-model="newContract"
          :options="
            newSpotStrip == null
              ? [{ asset: 'Loading...', id: 0 }]
              : newSpotStrip.length > 0
              ? newSpotStrip.map(function(d, i) {
                  return { asset: d.contract_month_year, id: i };
                })
              : [{ asset: 'Loading...', id: 0 }]
          "
          @change="onUserContractSelection"
          optionLabel="asset"
          optionValue="id"
          placeholder="Select Contract"
          scrollHeight="400px"
          :filter="true"
        >
          <template #value="slotProps">
            <span style="color: var(--textactive-2)">{{
              newSpotStrip[slotProps.value] != null
                ? newSpotStrip[slotProps.value].contract_month_year
                : "Loading..."
            }}</span>
          </template>
          <template #option="slotProps">
            <div class="country-item">
              <div>{{ slotProps.option.asset }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
    </div>

    <!-- <div
      class="row f-row mt-1 mb-1 justify-content-center"
      style="vertical-align: middle!important;"
      v-if="selectedAssetType === 1"
    >
      <div class="col col-auto txt-label-primary-2 text-center">
        <span style="padding: 0 8px 0 4px;">Last Trading Date:</span>
        {{ newSpotStrip[newContract].last_trading_date | dateFormat }}
      </div>
    </div> -->

    <div v-show="showStripData" class="opt-date-notional-div">
      <div
        class="row f-row mt-1 mb-1"
        style="vertical-align: middle!important;"
      >
        <div class="col col-6 txt-label-primary-2">
          Frequency:
        </div>
        <div class="col col-6 inline-ul selectDiv">
          <select
            class="dropdown-form"
            v-model="newFrequency"
            @change="onUserFrequencySelection"
          >
            <option
              v-for="option in frequencyOptions"
              :value="option.value"
              :key="option.id"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
      <div
        class="row f-row mt-1 mb-1"
        style="vertical-align: middle!important;"
      >
        <div class="col col-6 txt-label-primary-2">
          Initial date:
        </div>
        <div class="col col-6">
          <input
            type="date"
            class="custom-input"
            v-model="newInitialDate"
            @change="onUserDateChange"
          />
        </div>
      </div>
      <div
        class="row f-row mt-1 mb-1"
        style="vertical-align: middle!important;"
      >
        <div class="col col-6 txt-label-primary-2">
          # of dates:
        </div>
        <div class="col col-6 inline-ul">
          <input
            type="number"
            class="custom-input"
            v-model="newNDates"
            @change="onUserNDatesChange"
          />
        </div>
      </div>
      <div
        class="row f-row mt-1 mb-1"
        style="vertical-align: middle!important;"
      >
        <div class="col col-6 txt-label-primary-2">
          Amount per date:
        </div>
        <div class="col col-6 inline-ul">
          <InputNumber
            :value="notional"
            @input="val => onUserNotionalChange(val)"
          />
        </div>
      </div>
      <div
        class="row f-row mt-3 justify-content-center"
        style="vertical-align: middle!important;"
      >
        <div class="col col-4 txt-trade-div text-center">
          <input
            type="button"
            id="stripClose"
            class="inputFileBlue"
            @click="showStripData = false"
          />
          <label for="stripClose">Close</label>
        </div>
      </div>
    </div>

    <div
      class="row f-row mt-2 justify-content-center"
      style="vertical-align: middle!important;"
    >
      <div class="col col-2 txt-label-primary-2 text-center">
        <input
          type="button"
          id="strip"
          class="inputFileBlue"
          @click="showStripData = !showStripData"
        />
        <label for="strip">{{
          showStripData ? "Close" : "Define strip"
        }}</label>
      </div>
      <div class="col col-1">,</div>
      <div class="col col-2 txt-label-primary-2 text-center">
        <input
          type="file"
          name="file"
          id="file"
          class="inputFileBlue"
          @change="onUserFileUpload"
        />
        <label for="file"><i class="fa fa-upload"></i> Choose a file...</label>
      </div>
      <div class="col col-1 txt-label-primary-2">or</div>
      <div class="col col-2 inline-ul txt-label-primary-2 text-center">
        <input
          v-model="textIn"
          style="width: 100%; background: var(--dark-expo-alpha)!important;
          color: var(--textactive-2)!important; border: 1px solid var(--expo)!important;"
          type="text"
          @paste="onUserPasteDateNotional"
          class="btn-home btn btn-home-blue"
          placeholder="Paste dates/quantities"
        />
      </div>
    </div>

    <div class="col col-8" style="height: 100%; overflow: auto;">
      <table class="table table-sm table-borderless real_time_table mt-2">
        <thead class="table-headers text-center align-center thead">
          <tr>
            <th style="width: 10%">#</th>
            <th style="width: 35%">Date (mm/dd/yyyy)</th>
            <th style="width: 35%" v-if="selectedAssetType === 0">
              New hedge ({{ leftCurrency }})
            </th>
            <th style="width: 35%" v-else>
              New hedge ({{ currencySpecs[selectedAsset].fk_idunit }})
            </th>
            <th style="width: 20%">Delete</th>
          </tr>
        </thead>
      </table>
    </div>
    <div
      class="col col-8"
      style="height: 100%; overflow: auto;"
      v-bind:class="{
        strategiesTableHeight1: showCalculator,
        strategiesTableHeight2: !showCalculator
      }"
    >
      <table class="table table-sm table-borderless real_time_table">
        <tbody>
          <tr v-for="(item, index) in newUserNewHedge" :key="index" class="tr">
            <td
              style="width: 10%"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              {{ index + 1 }}
            </td>
            <td
              style="width: 35%"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              <input
                type="date"
                class="optim-input"
                v-model="item.date"
                @input="val => onUserSingleNotionalChange"
              />
            </td>
            <td
              style="width: 35%"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              <!-- <input type="text" v-model.number="item.newHedge" class="btn-home btn mt-3 ml-4"/> -->
              <InputNumber
                v-model.number="item.newHedge"
                :tableFormat="true"
                :pasted="pasted"
              />
            </td>
            <td
              style="width: 20%"
              class="text-center"
              v-bind:class="{ 'row-hover': highlightRow === index }"
              @mouseover="onHoverRow(index)"
              @mouseleave="onHoverRow(-1)"
            >
              <button
                v-show="newUserNewHedge.length > 1"
                class="btn detailView"
                @click="cancel(item)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col col-8" style="height: 100%; overflow: auto;">
      <table class="table table-sm table-borderless real_time_table">
        <thead>
          <tr>
            <th style="width: 10%">Total</th>
            <th style="width: 35%"></th>
            <th style="width: 35%; font-size: 1rem; text-align: right;">
              <span class="mr-1">{{ allSubTotal | formatM }}</span>
            </th>
            <th style="width: 30%" class="text-center">
              <button @click="add" class="btn detailView mr-2">
                <i class="fa fa-plus"></i>
                new date
              </button>
            </th>
          </tr>
        </thead>
      </table>
    </div>
  </div>
</template>

<script>
import Dropdown from "primevue/dropdown";
import InputNumber from "@/components/InputNumber";
import { nextDateByFrequency } from "@/_core/data/Optimizer";
import { date2Str } from "@/_core/_helpers/_helpers.js";
import { SheetsTransaction } from "@/_core/export/SheetsTransaction";
import { Holidays } from "@/_core/_helpers/holidays/Holidays";
import {
  darkBackground,
  grayLightBackground,
  textactive2
} from "@/_core/_helpers/_parametric_tools";
import { format, select, timeFormat, timeParse } from "d3";

export default {
  name: "DateNotionalTable",
  components: {
    Dropdown,
    InputNumber
  },
  props: {
    colorTheme: { required: true, type: Boolean, default: true },
    contract: { required: false, default: 1 },
    currencySpecs: { required: true, default: () => [] },
    frequency: { required: true, default: () => [] },
    frequencyOptions: { required: true, default: () => [] },
    getCountriesPair: { required: true },
    initialDate: { required: true, default: () => [] },
    nDates: { required: true, default: () => [] },
    notional: { required: true, default: () => [] },
    position: { required: true, default: () => [] },
    selectedAsset: { required: true, default: 2 },
    selectedAssetType: { required: true, default: () => [] },
    spotStrip: {
      required: false,
      default: () => [
        { contract_month_year: "Loading...", last_trading_date: new Date() }
      ]
    },
    showCalculator: { required: true, type: Boolean, default: false },
    userNewHedge: { required: true, default: () => [] }
  },
  data() {
    return {
      screenSize: null,
      tooltip: null,
      newContract: 1,
      newFrequency: null,
      newInitialDate: null,
      newNDates: null,
      newPosition: null,
      newSelectedAsset: 3,
      newUserNewHedge: [],
      newSpotStrip: [
        { contract_month_year: "Loading...", last_trading_date: new Date() }
      ],
      hedgeChanged: false,
      allNotional: 100000,
      allPercent: 0.1,
      sheetTransaction: null,
      showStripData: false,
      highlightRow: -1,
      tableData: [],
      tableRow: [],
      text: undefined,
      object: undefined,
      pasted: false,
      textIn: ""
    };
  },
  created() {
    try {
      this.countrySpecs = this.$store.state.countries.all.items;
    } catch (error) {
      console.log(`Error countries ${error}`);
    }
  },
  mounted() {
    this.newContract = this.contract - 1;
    this.newUserNewHedge = this.userNewHedge;
    this.newFrequency = this.frequency;
    this.newSelectedAsset = this.selectedAsset;
    this.newPosition = this.position;
    this.newInitialDate = this.initialDate;
    this.newNDates = this.nDates;
    this.screenSize = document.getElementById("whole-page-opt-div");
    this.screenSize = [
      0.2 * this.screenSize.clientHeight,
      0.25 * this.screenSize.clientWidth
    ];
    this.tooltip = select("#whole-page-opt-div")
      .append("div")
      .style("opacity", 0)
      .style("margin", 0)
      .style("padding", "8px")
      .style("text-align", "center")
      .style("background", darkBackground(this.colorTheme))
      .style("border", grayLightBackground(this.colorTheme))
      .style("color", textactive2(this.colorTheme))
      .attr("class", "tooltip")
      .style("font-size", "0.8rem")
      .style("width", "350px")
      .html("");
  },
  watch: {
    colorTheme() {
      this.tooltip
        .style("background", darkBackground(this.colorTheme))
        .style("border", grayLightBackground(this.colorTheme))
        .style("color", textactive2(this.colorTheme));
    },
    spotStrip() {
      this.newSpotStrip = this.spotStrip;
    },
    contract() {
      this.newContract = this.contract - 1;
    },
    userNewHedge() {
      this.newUserNewHedge = this.userNewHedge;
    },
    frequency() {
      this.newFrequency = this.frequency;
    },
    selectedAsset() {
      this.newSelectedAsset = this.selectedAsset;
    },
    position() {
      this.newPosition = this.position;
    },
    initialDate() {
      this.newInitialDate = this.initialDate;
    },
    nDates() {
      this.newNDates = this.nDates;
    }
  },
  computed: {
    leftCurrency() {
      if (this.selectedAssetType === 0) {
        return this.currencySpecs[this.newSelectedAsset].currency_name.slice(
          0,
          3
        );
      } else {
        return "N.A/N.A";
      }
    },
    allSubTotal() {
      return this.newUserNewHedge
        .map(item => +item.newHedge)
        .reduce((a, b) => a + b, 0);
    },
    selectedPositionBoolean: {
      get() {
        return this.newPosition === "sell";
      },
      set() {
        return false;
      }
    }
  },
  filters: {
    formatM(val) {
      return Math.abs(val) > 1000000000000
        ? format(",.2f")(val / 1000000000000) + "T"
        : Math.abs(val) > 10000000
        ? format(",.2f")(val / 1000000) + "M"
        : format(",.0f")(val);
    },
    formatPercent: function(value) {
      if (value) {
        return format(".1%")(value);
      }
    },
    dateFormat: function(val) {
      return val === null ||
        val === "" ||
        val === 0 ||
        +val < +new Date(1980, 1, 1)
        ? "-"
        : timeFormat("%d %b %y")(val);
    }
  },
  methods: {
    onHoverHelp(val) {
      let keys = Object.keys(this.currencySpecs[this.selectedAsset]);
      if (val && keys.indexOf("text") > -1) {
        this.tooltip
          .style("opacity", 1)
          .style("left", this.screenSize[1] + "px")
          .style("top", this.screenSize[0] + "px")
          .html(this.currencySpecs[this.selectedAsset].text);
      } else {
        this.tooltip
          .style("left", "-1000000px")
          .style("top", "0px")
          .style("opacity", 0)
          .html("");
      }
    },
    onHoverRow(idx) {
      this.highlightRow = idx;
    },
    onUserFileUpload(e) {
      const files = e.target.files;
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        this.newUserNewHedge = [];
        const data = ev.target.result;
        this.sheetTransaction = new SheetsTransaction();
        this.sheetTransaction.set_data(data);
        this.sheetTransaction.set_headers(this.newUserNewHedge);
        this.indexes = ["date", "newHedge"];
        if (this.selectedAssetType === 0) {
          this.sheetTransaction.import(this.indexes, {
            date: this.getCountriesPair(this)
          });
        } else {
          let country =
            this.currencySpecs[this.selectedAsset].fk_idcurrency === "MYR"
              ? "MYS"
              : "USA";
          this.sheetTransaction.import(this.indexes, {
            date: country
          });
        }
      };
      fileReader.readAsBinaryString(files[0]);
      setTimeout(() => {
        this.$emit("eventOnUserTableChange", this.newUserNewHedge);
      }, 1000);
    },
    onUserPasteDateNotional(e) {
      let holidays;
      if (this.selectedAssetType === 0) {
        holidays = new Holidays(this.getCountriesPair(this));
      } else {
        let country =
          this.currencySpecs[this.selectedAsset].fk_idcurrency === "MYR"
            ? "MYS"
            : "USA";
        holidays = new Holidays(country);
      }
      this.pasted = true;
      this.newUserNewHedge = [];
      this.text = e.clipboardData.getData("text");
      // try{
      let rows = this.text.split("\n");
      // rows.pop();
      for (let row of rows) {
        let cells = row.split("\t");
        let even = true;
        let newHedgeObject = {};
        for (let cell of cells) {
          if (even) {
            newHedgeObject.date = holidays.searchAvailableDate(cell);
            even = false;
          } else {
            newHedgeObject.newHedge = +(+cell.replace(",", "")).toString();
            even = true;
          }
        }
        this.newUserNewHedge.push(newHedgeObject);
      }
      this.$emit("eventOnUserTableChange", this.newUserNewHedge);
      setTimeout(() => {
        this.textIn = "";
      }, 2000);
    },
    add() {
      this.hedgeChanged = true;
      this.newNDates = +this.newNDates + 1;
      this.$emit("eventUpdateNDates", this.newNDates);
      let dat = timeParse("%Y-%m-%d")(
        this.newUserNewHedge[this.newUserNewHedge.length - 1].date
      );
      this.newUserNewHedge.push({
        date: date2Str(nextDateByFrequency(this.newFrequency, dat), 0),
        newHedge: this.notional
      });
      this.onUserSingleNotionalChange();
    },
    cancel(item) {
      this.hedgeChanged = true;
      this.newNDates = +this.newNDates - 1;
      this.$emit("eventUpdateNDates", this.newNDates);
      this.newUserNewHedge.splice(this.newUserNewHedge.indexOf(item), 1);
      this.onUserSingleNotionalChange();
    },
    remove(item, index) {
      this.hedgeChanged = true;
      this.selectedHedge.splice(index, 1);
    },
    onUserFrequencySelection() {
      this.$emit("eventOnUserFrequencySelection", this.newFrequency);
    },
    onUserAssetSelection() {
      this.$emit("eventOnUserAssetSelection", this.newSelectedAsset);
    },
    onUserContractSelection() {
      this.$emit("eventOnUserContractSelection", this.newContract + 1);
    },
    onUserPositionChange() {
      this.newPosition = this.newPosition === "buy" ? "sell" : "buy";
      this.$emit("eventOnUserPositionChange", this.newPosition);
    },
    onUserNotionalChange(val) {
      this.$emit("eventOnUserNotionalChange", val);
    },
    onUserSingleNotionalChange() {
      this.$emit("eventOnUserTableChange", this.newUserNewHedge);
    },
    onUserDateChange() {
      this.$emit("eventOnUserDateChange", this.newInitialDate);
    },
    onUserNDatesChange() {
      this.$emit("eventOnUserNDatesChange", this.newNDates);
    }
  }
};
</script>

<style scoped>
.p-dropdown {
  background: var(--dark-expo-alpha);
}
.p-dropdown:hover,
.p-dropdown:focus:hover,
.p-dropdown:focus,
.p-dropdown.active,
.p-dropdown::after {
  background: var(--expo) !important;
}
.toggle__button_rt .toggle__switch_rt::after,
.toggle__button_rt .toggle__switch_rt::before {
  content: "Buy";
  font-size: 0.75rem !important;
  padding: 0 !important;
}
.actives .toggle__switch_rt::before,
.actives .toggle__switch_rt::after {
  content: "Sell";
}
</style>
